/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';

const TaggedItem = ({
  activeLanguage, handlerSetComponents, components, languages, id, reusableComponent, reusableComponentSlugname, slider,
}) => {
  const initialState = {
    type: 'TaggedItem',
    text: {
      en: '',
    },
    color: '#000000',
  };
  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);

  const [text, setText] = useState({ 'en': '' });
  const [color, setColor] = useState('#000000');

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    if (reusableComponent) {
      setState(reusableComponent);
      if (!component) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
    } else {
      setIndex(componentIndex);
      if (component) {

        const {
          text: currentText,
          color: currentColor,
        } = component;

        setState(component);
        setText(currentText);
        setColor(currentColor);

      } else {
        const componentObj = {
          id,
          component: state,
        };

        handlerSetComponents(componentObj, componentIndex);
      }
    }
  }, [components]);

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const construction = {
      type: state.type,
      compId: state.compId || '',
      text: { ...text },
      color,
    }
    handlerSetComponents({ component: construction }, componentIndex);
  }, [
    text,
    color,
  ]);

  const titleChange = (e) => {
    text[activeLanguage] = e.target.value
    setText({ ...text });
  }

  return (
    <div className="flex justify-start flex-col text-black">
      {/* Single Form */}
      <div className="flex">
        <div className="flex-2 mr-4">
          <label
            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          >
            Title
          </label>
          <input
            className="appearance-none block
            bg-gray-200 text-gray-700 border border-red-500
            rounded py-3 px-4 w-full leading-tight focus:outline-none
            focus:bg-white"
            type="text"
            onChange={titleChange}
            value={text[activeLanguage]}
          />
        </div>
        <div className="">
          <label
            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            htmlFor="grid-first-name">
            Text Color
                </label>
          <div className="relative">
            <input
              className="appearance-none uppercase block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
              id="grid-first-name"
              type="text"
              onChange={e => setColor(e.target.value)}
              value={color}
            />
            <input
              className="absolute bg-transparent flex h-full items-center p-1 right-0 text-gray-700 top-0"
              name="color"
              type="color"
              onChange={e => setColor(e.target.value)}
              value={color}
            />
          </div>
        </div>
      </div>
      {/* End */}

    </div>
  );
};

TaggedItem.propTypes = {
  activeLanguage: PropTypes.string.isRequired,
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
  reusableComponent: PropTypes.shape(),
  slider: PropTypes.bool,
};
TaggedItem.defaultProps = {
  reusableComponent: null,
  slider: false,
};

export default TaggedItem;
